<template>
  <div class="page">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="40%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('openConfig.addName')"
      class-name="vertical-center-modal"
    >
      <div class="modalContainer">
        <Form
          ref="addForm"
          :label-width="130"
          :model="addForm"
          label-colon
          :rules="ruleValidate"
        >
          <FormItem :label="$t('openConfig.devType')" prop="devType">
            <Select
              v-model="addForm.devType"
              size="large"
              :placeholder="$t('openConfig.devTypeTip')"
            >
              <Option
                v-for="(item, index) in devTypeList"
                :key="index"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('openConfig.room')" prop="room">
            <Input
              v-model="addForm.room"
              size="large"
              :maxlength="24"
              :placeholder="$t('openConfig.roomTip')"
              clearable
            />
          </FormItem>
          <FormItem :label="$t('openConfig.name')" prop="name">
            <Input
              v-model="addForm.name"
              size="large"
              :maxlength="10"
              :placeholder="$t('openConfig.nameTip')"
              clearable
            />
          </FormItem>

          <FormItem :label="$t('openConfig.pic')">
            <form id="uploadImg">
              <div class="img-box">
                <div
                  class="img-item"
                  :class="{ 'form-box-margin': facePicUrl !== '' }"
                  v-if="facePicUrl !== ''"
                >
                  <Badge>
                    <div class="url-box">
                      <img :src="facePicUrl" class="url-img" />
                    </div>
                    <Icon
                      type="md-remove-circle"
                      slot="count"
                      class="close-badge"
                      @click="delImg(index)"
                    />
                  </Badge>
                </div>
                <div class="img-item" v-show="facePicUrl === ''">
                  <div class="form-box">
                    <a href="javascript:;" class="file">
                      <Icon type="md-add" class="add-icon" />
                      <input
                        type="file"
                        name="facePic"
                        accept=".jpg,.png,.jpeg"
                        @change="showPic($event)"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </FormItem>
        </Form>
      </div>
      <div class="detailBackBtn">
        <Button size="large" @click="closeModal">{{
          $t("common.cancel")
        }}</Button>
        <Button type="primary" size="large" @click="addNameSingle">{{
          $t("common.ensure")
        }}</Button>
      </div>
    </Modal>
    <div class="content_win"></div>
  </div>
</template>

<script>
export default {
  name: "ModalBox",
  props: {},
  data() {
    return {
      dialogVisible: false,
      addForm: {},
      modalType: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t("openConfig.checkName"),
            trigger: "blur",
          },
        ],
        room: [
          {
            required: true,
            message: this.$t("openConfig.checkRoom"),
            trigger: "blur",
          },
        ],
        devType: [
          {
            required: true,
            message: this.$t("openConfig.checkDevType"),
            trigger: "change",
            type: "string",
          },
        ],
      },
      devTypeList: [
        {
          name: this.$t("openConfig.IS"),
          value: "IS",
        },
        {
          name: this.$t("openConfig.GU"),
          value: "GU",
        },
        {
          name: this.$t("openConfig.OS1"),
          value: "OS1",
        },
        {
          name: this.$t("openConfig.OS2"),
          value: "OS2",
        },
        {
          name: this.$t("openConfig.OS3"),
          value: "OS3",
        },
      ],
      facePicUrl: "",
    };
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          this.$refs.addForm.resetFields();
          document.getElementById("uploadImg").reset();
          this.facePicUrl = "";

          this.addForm = {};
          // 弹窗关闭 清空数据
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.dialogVisible = false;
    },

    // 删除人脸
    delImg() {
      this.facePicUrl = "";
      document.getElementById("uploadImg").reset();
    },
    //  从系统文件选择图片
    showPic($event) {
      let el = $event.currentTarget;
      let file = el.files[0];

      // 检验格式
      let lastName = file.name.split(".").reverse()[0];
      let allowPicReg = ["jpg", "png", "jpeg"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("userCenter.imgRegTip"));
        file = this.currentFile;
      } else {
        let url = null;
        this.currentFile = file;
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }

        this.facePicUrl = url;
        this.addForm.pic = el.files[0];
        this.addForm.facePicUrl = url;

        this.$forceUpdate();
      }
    },
    addNameSingle() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let obj = {
            room: this.addForm.room,
            name: this.addForm.name,
            devType: this.addForm.devType,
          };

          obj = JSON.parse(JSON.stringify(obj));
          if (this.addForm.pic) {
            obj.pic = this.addForm.pic;
            obj.facePicUrl = this.addForm.facePicUrl;
          }
          this.$emit("getList", obj);
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.required-span {
  position: absolute;
  color: #ed4014;
  line-height: 35px;
  font-size: 14px;
  font-weight: 600;
  left: 21%;
}
.require-tip {
  line-height: 18px;
  color: #ed4014;
  position: relative;
  left: 23%;
  top: -20px;
}
.tip-height {
  height: 20px;
}
.img-box {
  display: flex;
  flex-direction: row;
  .img-item {
    .close-badge {
      font-size: 20px;
      color: #ed4014;
      cursor: pointer;
    }
    .url-box {
      .url-img {
        width: auto;
        height: auto;
        max-height: 100px;
        max-width: 100px;
        border-radius: 5px;
      }
    }
    .url-box,
    .form-box {
      width: 100px;
      height: 100px;
      background: #f9f9f9;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .form-box {
      border: 1px solid #e3e3e3;
      border-radius: 5px;
      border-style: dashed;

      .file {
        position: relative;
        display: inline-block;
        overflow: hidden;
        text-align: center;
        .add-icon {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 64px;
          color: #dddddd;
        }
      }

      .file input {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
  .form-box-margin {
    margin-right: 20px;
  }
}
</style>
